<template>
  <!-- ステータスが「完了済」の場合は表示しない -->
  <v-menu
    v-if="!disableMenuStatuses.includes(schedule.status)"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>

    <!-- 種別が「回収」 -->
    <v-list
      v-if="schedule.schedule_type === 'collection'"
      dense
    >
      <v-list-item
        link
        @click="instructionEditButtonClickEvent"
      >
        <v-list-item-title>
          指示メモを編集
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        link
        @click="registerVehicleButtonClickEvent"
      >
        <v-list-item-title>
          車両を指定
        </v-list-item-title>
      </v-list-item>

      <!-- ステータスが「受注」であること -->
      <v-list-item
        v-if="cancelStatuses.includes(schedule.status)"
        link
        @click="releaseDispatchButtonClickEvent"
      >
        <v-list-item-title>
          <strong class="error--text">
            配車を解除
          </strong>
        </v-list-item-title>
      </v-list-item>

      <!-- ステータスが「確定済、回収完了、運搬完了」 -->
      <v-list-item
        v-else-if="false"
        link
        @click="cancelDispatchButtonClickEvent"
      >
        <v-list-item-title>
          <strong class="error--text">
            キャンセル
          </strong>
        </v-list-item-title>
      </v-list-item>
    </v-list>

    <!-- 種別が「その他指示メモ」 -->
    <v-list
      v-else-if="schedule.schedule_type === 'instruction'"
      dense
    >
      <v-list-item
        link
        @click="registerMemoButtonClickEvent"
      >
        <v-list-item-title>
          指示を編集
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        link
        @click="removeMemoButtonClickEvent"
      >
        <v-list-item-title>
          <strong class="error--text">
            指示を削除
          </strong>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'UserTaskCardMenus',
  components: {},
  mixins: [],
  props: {
    /**
     * @param schedule { Object }
     * @property schedule.schedule_type {string} 種別
     * @property schedule.status { String } マニフェストステータス
     */
    schedule: {
      type: [Object, Array],
      default: () => null,
    },
    isPrevious: {
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      disableMenuStatuses: [ 'collection_completed', 'pickup_completed', 'carry_completed' ],
      cancelStatuses: [
        'collection_accepted', 'collection_allocated', 'collection_reserved', 'collection_transported',
        'pickup_accepted', 'pickup_allocated', 'pickup_transported',
        'carry_in_accepted', 'carry_allocated', 'carry_transported'
      ]
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    /**
     * 指示メモ編集ボタン クリックイベント
     */
    instructionEditButtonClickEvent () {
      this.$emit('collectionCardMenuCallback', 'instruction_edit', this.schedule)
    },
    /**
     * 車両を指定ボタン クリックイベント
     */
    registerVehicleButtonClickEvent () {
      this.$emit('collectionCardMenuCallback', 'register_vehicle', this.schedule)
    },
    /**
     * 配車を解除するボタン クリックイベント
     */
    releaseDispatchButtonClickEvent () {
      this.$emit('collectionCardMenuCallback', 'release_dispatch', this.schedule)
    },
    /**
     * 配車キャンセルボタン クリックイベント
     */
    cancelDispatchButtonClickEvent () {
      this.$emit('collectionCardMenuCallback', 'cancel_dispatch', this.schedule)
    },
    /**
     * その他指示メモ編集ボタン クリックイベント
     */
    registerMemoButtonClickEvent () {
      this.$emit('instructionCardMenuCallback', 'register_memo', this.schedule)
    },
    /**
     * 指示を削除ボタン クリックイベント
     */
    removeMemoButtonClickEvent () {
      this.$emit('instructionCardMenuCallback', 'remove_memo', this.schedule)
    },
  }
}
</script>

<style scoped lang="scss">

</style>
